import { relations } from 'drizzle-orm';
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core';
import { roleTable } from './role.sql';
import { userTable } from './user.sql';

export const userRoleTable = pgTable(
  'user_role',
  {
    userId: uuid('userId')
      .notNull()
      .references(() => userTable.id),
    roleId: uuid('roleId')
      .notNull()
      .references(() => roleTable.id),
  },
  (t) => [primaryKey({ columns: [t.roleId, t.userId] })],
);

export const userRoleRelations = relations(userRoleTable, ({ one }) => ({
  user: one(userTable, {
    fields: [userRoleTable.userId],
    references: [userTable.id],
  }),
  role: one(roleTable, {
    fields: [userRoleTable.roleId],
    references: [roleTable.id],
  }),
}));
